var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { Box, RadioGroup, FormControl, FormControlLabel } from "@mui/material";
import { ClearApplyButtons } from "../../../../../Common";
import { RadioButton } from "../../../../../Atoms";
import { COLORS } from "../../../../../../constants";
var radioControl = _jsx(RadioButton, { color: "primary", sx: { mr: 2 } });
var RadioFilter = function (_a) {
    var _b = _a.defaultValueLabel, defaultValueLabel = _b === void 0 ? "Any" : _b, value = _a.value, options = _a.options, onClear = _a.onClear, onSubmit = _a.onSubmit;
    var initialValue = value || "any";
    var _c = __read(useState(initialValue), 2), localVal = _c[0], setLocalVal = _c[1];
    var handleSubmit = function () {
        onSubmit({ value: localVal });
    };
    var handleChange = function (event) {
        setLocalVal(event.target.value);
    };
    return (_jsxs(_Fragment, { children: [_jsx(Box, __assign({ sx: {
                    py: 4,
                    px: 2,
                    border: "1px solid ".concat(COLORS.P_OUTLINE),
                    borderRadius: 2,
                } }, { children: _jsx(FormControl, __assign({ sx: { px: 5 } }, { children: _jsxs(RadioGroup, __assign({ value: localVal, onChange: handleChange }, { children: [_jsx(FormControlLabel, { value: "any", label: defaultValueLabel, control: radioControl }), options.map(function (option) { return (_jsx(FormControlLabel, { value: option.value, label: option.label, control: radioControl }, option.value)); })] })) })) })), _jsx(ClearApplyButtons, { handleSubmit: handleSubmit, onClear: onClear })] }));
};
export default RadioFilter;
